(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawlido-cart-studio"]) return;
  try {
    
  (() => {
    const form = document.querySelector('.ps-cart-form');
    if (!form || form.dataset.autoUpdateReady === 'true') return;
    const pending = new Map();
    const root = window.Shopify?.routes?.root || '/';
    const section = form.closest('.shopify-section[id]');
    const sectionId = section?.id.replace('shopify-section-', '') || '';
    let timer = 0;
    let updating = false;
    let checkoutQueued = false;
    const statusElement = () => form.querySelector('#PawlidoCartUpdateStatus');
    const quantityInputs = () => [...form.querySelectorAll('.ps-cart-quantity[data-cart-line-key]')];
    const quantityButtons = () => [...form.querySelectorAll('.ps-cart-quantity-button')];
    const checkoutButton = () => form.querySelector('[name="checkout"]');
    const message = (name, state = '') => {
      const status = statusElement();
      if (!status) return;
      status.textContent = status.dataset[name] || '';
      status.dataset.state = state;
      status.hidden = !status.textContent;
    };
    const setBusy = (busy) => {
      form.setAttribute('aria-busy', String(busy));
      quantityInputs().forEach((input) => { input.disabled = busy; });
      quantityButtons().forEach((button) => { button.disabled = busy; });
      const button = checkoutButton();
      if (button) button.setAttribute('aria-busy', String(busy));
    };
    const parseQuantity = (input) => {
      const quantity = Number(input.value);
      if (input.value.trim() === '' || !Number.isInteger(quantity) || quantity < 0) return null;
      return quantity;
    };
    const waitForConversion = async () => {
      if (typeof window.bucksCC?.reConvert !== 'function') return false;
      window.bucksCC.reConvert();
      const selectedCurrency = document.querySelector('.bucks-selected')?.textContent?.trim();
      const converted = () => {
        const prices = [...form.querySelectorAll('.money')];
        if (!prices.length) return false;
        if (!selectedCurrency || selectedCurrency === 'USD') return prices.every((price) => /\bUSD\b/.test(price.textContent || ''));
        return prices.every((price) => price.getAttribute('bucks-currency') === selectedCurrency || (price.textContent || '').includes(selectedCurrency));
      };
      if (converted()) return true;
      return new Promise((resolve) => {
        let attempts = 0;
        const check = () => {
          if (converted()) { resolve(true); return; }
          attempts += 1;
          if (attempts >= 20) { resolve(false); return; }
          window.setTimeout(check, 50);
        };
        check();
      });
    };
    const renderCart = async (cart) => {
      const html = sectionId ? cart.sections?.[sectionId] : '';
      if (!html) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextForm = parsed.querySelector('.ps-cart-form');
      const currentItems = form.querySelector('.ps-cart-items');
      const currentSummary = form.querySelector('.ps-cart-summary');
      const nextItems = nextForm?.querySelector('.ps-cart-items');
      const nextSummary = nextForm?.querySelector('.ps-cart-summary');
      if (!currentItems || !currentSummary || !nextItems || !nextSummary) return false;
      currentItems.replaceWith(nextItems);
      currentSummary.replaceWith(nextSummary);
      document.querySelectorAll('.ps-cart-count').forEach((count) => { count.textContent = `(${cart.item_count})`; });
      form.setAttribute('aria-busy', 'false');
      return waitForConversion();
    };
    const stage = (input) => {
      const quantity = parseQuantity(input);
      if (quantity === null) {
        input.setAttribute('aria-invalid', 'true');
        pending.delete(input.dataset.cartLineKey);
        window.clearTimeout(timer);
        message('invalid', 'error');
        return;
      }
      input.removeAttribute('aria-invalid');
      pending.set(input.dataset.cartLineKey, quantity);
      window.clearTimeout(timer);
      message('updating');
      timer = window.setTimeout(() => flush(false), 250);
    };
    const flush = async (goToCheckout) => {
      checkoutQueued = checkoutQueued || goToCheckout;
      window.clearTimeout(timer);
      timer = 0;
      if (updating) return;
      if (!pending.size) {
        if (checkoutQueued) window.location.assign(root + 'checkout');
        return;
      }
      const updates = Object.fromEntries(pending);
      pending.clear();
      updating = true;
      setBusy(true);
      message('updating');
      try {
        const body = { updates };
        if (sectionId) {
          body.sections = [sectionId];
          body.sections_url = window.location.pathname + window.location.search;
        }
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error('Cart update failed: ' + response.status);
        const cart = await response.json();
        if (checkoutQueued) { window.location.assign(root + 'checkout'); return; }
        const rendered = await renderCart(cart);
        if (!rendered) { window.location.reload(); return; }
        setBusy(false);
        updating = false;
        checkoutQueued = false;
        message('updated');
      } catch (error) {
        Object.entries(updates).forEach(([id, quantity]) => pending.set(id, quantity));
        form.classList.remove('ps-cart-form--enhanced');
        message('error', 'error');
        setBusy(false);
        updating = false;
      }
    };
    form.addEventListener('input', (event) => {
      const input = event.target.closest('.ps-cart-quantity[data-cart-line-key]');
      if (input) stage(input);
    });
    form.addEventListener('focusout', (event) => {
      const input = event.target.closest('.ps-cart-quantity[data-cart-line-key]');
      if (input && parseQuantity(input) === null) message('invalid', 'error');
    });
    form.addEventListener('click', (event) => {
      const button = event.target.closest('.ps-cart-quantity-button');
      if (!button) return;
      const input = button.closest('.ps-cart-quantity-control')?.querySelector('.ps-cart-quantity');
      if (!input) return;
      const current = parseQuantity(input) ?? 0;
      const change = button.dataset.cartAction === 'increase' ? 1 : -1;
      input.value = String(Math.max(0, current + change));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    form.addEventListener('submit', (event) => {
      if (!form.classList.contains('ps-cart-form--enhanced')) return;
      const submitterName = event.submitter?.name;
      const quantityFocused = document.activeElement?.classList.contains('ps-cart-quantity');
      if (submitterName === 'update' || (quantityFocused && !submitterName)) { event.preventDefault(); flush(false); return; }
      if (submitterName === 'checkout' && (timer || pending.size || updating)) { event.preventDefault(); flush(true); }
    });
    form.dataset.autoUpdateReady = 'true';
    form.classList.add('ps-cart-form--enhanced');
    form.setAttribute('aria-busy', 'false');
    message('');
  })();

  } catch(e) { console.error(e); }
})();
})();
